import React from "react";
import { useSelector } from "react-redux";
import { getSecurityUiConfig } from "../../../../base/config/functions.any";
import { isLocalParticipantModerator } from "../../../../base/participants/functions";
import Dialog from "../../../../base/ui/components/web/Dialog";
import { isInBreakoutRoom } from "../../../../breakout-rooms/functions";
import LobbySection from "../../../../lobby/components/web/LobbySection";
import { isEnablingLobbyAllowed } from "../../../../lobby/functions";
/**
 * Component that renders the security options dialog.
 *
 * @returns {React$Element<any>}
 */
export default function SecurityDialog() {
    const lobbySupported = useSelector((state) => state["features/base/conference"].conference?.isLobbySupported());
    const e2eeSupported = useSelector((state) => state["features/base/conference"].e2eeSupported);
    const isInBreakout = useSelector(isInBreakoutRoom);
    const disableLobbyPassword = useSelector((state) => getSecurityUiConfig(state)?.disableLobbyPassword) || isInBreakout;
    const isModerator = useSelector(isLocalParticipantModerator);
    const { hideLobbyButton } = useSelector(getSecurityUiConfig);
    const _isLobbyVisible = useSelector(isEnablingLobbyAllowed) && lobbySupported && isModerator && !isInBreakout && !hideLobbyButton;
    const showE2ee = Boolean(e2eeSupported) && isModerator;
    return (React.createElement(Dialog, { cancel: { hidden: true }, ok: { hidden: true }, titleKey: "security.title" },
        React.createElement("div", { className: "security-dialog" }, _isLobbyVisible && React.createElement(LobbySection, null))));
}
